export function PrivacyPolicy() {
  return (
    <>
      <section>
        <h2>1. Introduction</h2>
        <p>
          Pediatric Speech Solutions ("Pediatric Speech Solutions," "we," "us," or "our") respects
          your privacy and is committed to protecting the personal information you share with us
          through this website (the "Site"). This Privacy Policy explains what information we
          collect, how we use and protect it, and the choices you have regarding your information.
        </p>
        <p>
          This Privacy Policy applies only to information collected through this Site. It does not
          apply to protected health information collected in connection with the direct provision
          of speech-language pathology services, which is governed separately under applicable
          health privacy laws and any Notice of Privacy Practices provided to clients.
        </p>
      </section>

      <section>
        <h2>2. Information We Collect</h2>
        <p>We may collect the following categories of information:</p>
        <ul>
          <li>
            <strong className="text-foreground font-medium">Contact information</strong> you
            voluntarily submit through our contact form, such as your name, email address, and any
            details you provide about your child or your inquiry.
          </li>
          <li>
            <strong className="text-foreground font-medium">Usage data</strong> such as your IP
            address, browser type, device information, pages visited, and the date and time of
            your visit, collected automatically through standard web server logs and analytics
            tools.
          </li>
          <li>
            <strong className="text-foreground font-medium">Cookies and similar technologies</strong>{" "}
            used to operate and improve the Site, as described in Section 5 below.
          </li>
        </ul>
      </section>

      <section>
        <h2>3. How We Use Your Information</h2>
        <p>We use the information we collect to:</p>
        <ul>
          <li>Respond to inquiries and requests for a free consultation;</li>
          <li>Schedule and coordinate speech-language therapy services;</li>
          <li>Communicate with you about our services;</li>
          <li>Maintain, improve, and secure the Site; and</li>
          <li>Comply with applicable legal obligations.</li>
        </ul>
        <p>We do not sell your personal information to third parties.</p>
      </section>

      <section>
        <h2>4. How We Share Your Information</h2>
        <p>We may share your information with:</p>
        <ul>
          <li>
            Service providers who help us operate the Site or our practice (for example, hosting,
            email, and scheduling providers), who are only permitted to use your information to
            provide services to us;
          </li>
          <li>Professional advisors, such as legal or accounting professionals, as needed; and</li>
          <li>
            Government authorities or other parties when required by law, or to protect the
            rights, property, or safety of Pediatric Speech Solutions, our clients, or others.
          </li>
        </ul>
      </section>

      <section>
        <h2>5. Cookies &amp; Analytics</h2>
        <p>
          When you first visit this Site, a privacy banner asks how you would like your
          information handled. Nothing beyond what is strictly necessary is loaded or stored
          until you choose. We group cookies and similar technologies into three categories:
        </p>
        <ul>
          <li>
            <strong>Strictly Necessary.</strong> Required for the Site to function — page
            navigation, form security, and remembering the privacy choice you make in the
            banner. These are always active and cannot be switched off.
          </li>
          <li>
            <strong>Analytics.</strong> Google Analytics 4, which tells us in aggregate which
            pages visitors find useful so we can improve the Site. If you decline, Google
            Analytics is not loaded and any analytics cookies already on your device are
            cleared.
          </li>
          <li>
            <strong>Marketing &amp; Email.</strong> Allows us to follow up by email with
            practice news, developmental tips, and schedule openings, and to measure whether
            our advertising reaches the right families. If you decline, you will not be added
            to any marketing email list and advertising identifiers are not stored.
          </li>
        </ul>
        <p>
          You can change your mind at any time using the <strong>Cookie Preferences</strong>
          link in the footer of every page. Your choice is stored in a first-party cookie on
          your own device for six months, after which we will ask again. We also honor Google
          Consent Mode, so declining is passed on to Google&rsquo;s tags rather than simply
          hidden from view. You can additionally control cookies through your browser
          settings; disabling cookies entirely may affect certain features of the Site.
        </p>
      </section>

      <section>
        <h2>6. Children's Privacy</h2>
        <p>
          This Site is intended for use by parents, guardians, and other adults on behalf of
          themselves or their children. We do not knowingly collect personal information directly
          from children through the Site. Any information about a child submitted through our
          contact form is provided voluntarily by a parent or guardian.
        </p>
      </section>

      <section>
        <h2>7. Data Security</h2>
        <p>
          We use reasonable administrative, technical, and physical safeguards designed to protect
          the information you provide. However, no method of transmission over the Internet or
          electronic storage is completely secure, and we cannot guarantee absolute security.
        </p>
      </section>

      <section>
        <h2>8. Your Choices &amp; Rights</h2>
        <p>
          You may contact us at any time to ask questions about the personal information we hold
          about you, to request that we correct or delete it, or to opt out of future
          communications, subject to any recordkeeping obligations we may have as a healthcare
          provider.
        </p>
        <p>
          For analytics and marketing specifically, you do not need to contact us at all — use
          the <strong>Cookie Preferences</strong> link in the footer of any page to withdraw
          your consent, and it takes effect immediately. Every marketing email we send also
          includes an unsubscribe link.
        </p>
      </section>

      <section>
        <h2>9. Third-Party Links</h2>
        <p>
          The Site may contain links to third-party websites, including social media platforms
          such as Facebook and Instagram. We are not responsible for the privacy practices or
          content of those third-party sites, and we encourage you to review their privacy
          policies.
        </p>
      </section>

      <section>
        <h2>10. Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Any changes will be posted on this
          page with a revised effective date. Your continued use of the Site after changes are
          posted constitutes your acceptance of the updated policy.
        </p>
      </section>

      <section>
        <h2>11. Contact Us</h2>
        <p>
          If you have questions about this Privacy Policy or how we handle your information,
          please contact us through the form on our website or via our social media pages linked
          in the footer of this Site.
        </p>
      </section>
    </>
  );
}
